// Import images
import AppCustomizationSpecialist from './AppCustomizationSpecialist.png';
import ApprovalProcess from './ApprovalProcess.png';
import BusinessAdministrationSpecialist from './BusinessAdministrationSpecialist.png';
import FlowAdministration from './FlowAdministration.png';
import FlowCollectionsAndLoops from './FlowCollectionsAndLoops.png';
import FlowFundamentals from './FlowFundamentals.png';
import FlowOptimization from './FlowOptimization.png';
import LightningExperienceRolloutSpecialist from './LightningExperienceRolloutSpecialist.png';
import ObjectRelationships from './ObjectRelationships.png';
import ProcessAutomationSpecialist from './ProcessAutomationSpecialist.png';
import RecordTriggeredFlow from './RecordTriggeredFlow.png';
import ReportsDashboardsSpecialist from './ReportsDashboardsSpecialist.png';
import SalesPathAndInteractions from './SalesPathAndInteractions.png';
import ScreenFlowDistribution from './ScreenFlowDistribution.png';
import ScreenFlowFundamentals from './ScreenFlowFundamentals.png';
import SecuritySpecialist from './SecuritySpecialist.png';
import FlowDataCollectionsOptimization from './FlowDataCollectionsOptimization.png';
import ScheduledFlowAndSubflow from './ScheduledFlowAndSubflow.png';
import PromptBuilderTemplates from './PromptBuilderTemplates.png';
import AgentforceService from './AgentforceService.png';
import FlowInteractions from './FlowInteractions.png';
import DataQualityValidation from './DataQualityAndValidation.png';
import FlowErrorHandling from './FlowErrorHandling.png';
import FlowDebugging from './FlowDebugging.png';
import Formulas from './Formulas.png';

// Map certification names to images
const superbadgeMap = {
  "SecuritySpecialist": SecuritySpecialist,
  "BusinessAdministrationSpecialist": BusinessAdministrationSpecialist,
  "ApprovalProcessManagement": ApprovalProcess,
  "FlowOptimization": FlowOptimization,
  "FlowAdministration": FlowAdministration,
  "ProcessAutomationSpecialist": ProcessAutomationSpecialist,
  "AppCustomizationSpecialist": AppCustomizationSpecialist,
  "RecordTriggeredFlow": RecordTriggeredFlow,
  "LightningExperienceRolloutSpecialist": LightningExperienceRolloutSpecialist,
  "LightningReportsDashboardsSpecialist": ReportsDashboardsSpecialist,
  "ObjectRelationships": ObjectRelationships,
  "FlowFundamentals": FlowFundamentals,
  "SalesPathAndInteractions": SalesPathAndInteractions,
  "FlowCollectionsAndLoops": FlowCollectionsAndLoops,
  "ScreenFlowFundamentals": ScreenFlowFundamentals,
  "ScreenFlowDistribution": ScreenFlowDistribution,
  "FlowDataCollectionsOptimization": FlowDataCollectionsOptimization,
  "ScheduledFlowAndSubflow": ScheduledFlowAndSubflow,
  "PromptBuilderTemplates": PromptBuilderTemplates,
  "AgentforceService": AgentforceService,
  "FlowInteractions": FlowInteractions,
  "DataQualityAndValidation": DataQualityValidation,
  "FlowErrorHandling": FlowErrorHandling,
  "FlowDebugging": FlowDebugging,
  "Formulas": Formulas
};

// Export both the map and a default
export { superbadgeMap };